import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback({ onLogin }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Check for Google OAuth code (from our custom OAuth)
      const code = searchParams.get('code');
      
      // Check for Emergent session_id (from Emergent auth)
      const hash = window.location.hash;
      const hashParams = new URLSearchParams(hash.replace('#', ''));
      const sessionId = hashParams.get('session_id');

      if (code) {
        // Handle custom Google OAuth callback
        try {
          const response = await axios.post(`${API_URL}/api/auth/google/callback?code=${encodeURIComponent(code)}`);
          const { access_token, user } = response.data;
          localStorage.setItem('token', access_token);
          onLogin(access_token, user);
          toast.success(`Hoş geldiniz, ${user.name}!`);
          navigate('/dashboard', { replace: true });
        } catch (error) {
          const msg = error.response?.data?.detail || 'Google ile giriş başarısız';
          toast.error(msg);
          navigate('/login', { replace: true });
        }
      } else if (sessionId) {
        // Handle Emergent Auth callback
        try {
          const response = await axios.post(`${API_URL}/api/auth/google-session`, {
            session_id: sessionId
          });
          const { access_token, user } = response.data;
          localStorage.setItem('token', access_token);
          onLogin(access_token, user);
          toast.success(`Hoş geldiniz, ${user.name}!`);
          navigate('/dashboard', { replace: true });
        } catch (error) {
          const msg = error.response?.data?.detail || 'Google ile giriş başarısız';
          toast.error(msg);
          navigate('/login', { replace: true });
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [navigate, onLogin, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground">Google ile giriş yapılıyor...</p>
      </div>
    </div>
  );
}
